import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchDisciplines: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'discipline/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_DISCIPLINE_REQUEST,
                        types.SEARCH_DISCIPLINE_SUCCESS,
                        types.SEARCH_DISCIPLINE_FAILURE
                    ]
                }
            });
        },

    listDisciplines: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'discipline/list',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.LIST_DISCIPLINE_REQUEST,
                        types.LIST_DISCIPLINE_SUCCESS,
                        types.LIST_DISCIPLINE_FAILURE
                    ]
                }
            });
        },

    saveDiscipline: (discipline) =>
        (dispatch) => {
            if (discipline.id === 0) {
                // Create
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'discipline/create',
                        method: 'POST',
                        body: discipline,
                        types: [
                            types.CREATE_DISCIPLINE_REQUEST,
                            types.CREATE_DISCIPLINE_SUCCESS,
                            types.CREATE_DISCIPLINE_FAILURE
                        ]
                    }
                });
            } else {
                // Update
                return dispatch({
                    [CALL_API]: {
                        endpoint: 'discipline/update',
                        method: 'PUT',
                        body: discipline,
                        types: [
                            types.UPDATE_DISCIPLINE_REQUEST,
                            types.UPDATE_DISCIPLINE_SUCCESS,
                            types.UPDATE_DISCIPLINE_FAILURE
                        ]
                    }
                });
            }
        }
}
